"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var revert_error_1 = require("../../revert_error");
// tslint:disable:max-classes-per-file
var UnregisteredAssetProxyError = /** @class */ (function (_super) {
    __extends(UnregisteredAssetProxyError, _super);
    function UnregisteredAssetProxyError() {
        return _super.call(this, 'UnregisteredAssetProxyError', 'UnregisteredAssetProxyError()', {}) || this;
    }
    return UnregisteredAssetProxyError;
}(revert_error_1.RevertError));
exports.UnregisteredAssetProxyError = UnregisteredAssetProxyError;
var InsufficientEthForFeeError = /** @class */ (function (_super) {
    __extends(InsufficientEthForFeeError, _super);
    function InsufficientEthForFeeError(ethFeeRequired, ethAvailable) {
        return _super.call(this, 'InsufficientEthForFeeError', 'InsufficientEthForFeeError(uint256 ethFeeRequired, uint256 ethAvailable)', { ethFeeRequired: ethFeeRequired, ethAvailable: ethAvailable }) || this;
    }
    return InsufficientEthForFeeError;
}(revert_error_1.RevertError));
exports.InsufficientEthForFeeError = InsufficientEthForFeeError;
var DefaultFunctionWethContractOnlyError = /** @class */ (function (_super) {
    __extends(DefaultFunctionWethContractOnlyError, _super);
    function DefaultFunctionWethContractOnlyError(senderAddress) {
        return _super.call(this, 'DefaultFunctionWethContractOnlyError', 'DefaultFunctionWethContractOnlyError(address senderAddress)', {
            senderAddress: senderAddress,
        }) || this;
    }
    return DefaultFunctionWethContractOnlyError;
}(revert_error_1.RevertError));
exports.DefaultFunctionWethContractOnlyError = DefaultFunctionWethContractOnlyError;
var EthFeeLengthMismatchError = /** @class */ (function (_super) {
    __extends(EthFeeLengthMismatchError, _super);
    function EthFeeLengthMismatchError(ethFeesLength, feeRecipientsLength) {
        return _super.call(this, 'EthFeeLengthMismatchError', 'EthFeeLengthMismatchError(uint256 ethFeesLength, uint256 feeRecipientsLength)', {
            ethFeesLength: ethFeesLength,
            feeRecipientsLength: feeRecipientsLength,
        }) || this;
    }
    return EthFeeLengthMismatchError;
}(revert_error_1.RevertError));
exports.EthFeeLengthMismatchError = EthFeeLengthMismatchError;
var types = [InsufficientEthForFeeError, DefaultFunctionWethContractOnlyError, EthFeeLengthMismatchError];
try {
    // Register the types we've defined.
    for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
        var type = types_1_1.value;
        revert_error_1.RevertError.registerType(type);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=mixin_weth_utils_revert_errors.js.map